import { defineFetch } from 'resift';
import _get from 'lodash/get';

export default defineFetch({
  displayName: 'create category field',
  make: () => ({
    key: [],
    request: (data: any) => async ({ http }) => {
      try {
        const response = await http({
          method: 'POST',
          route: '/fields',
          data,
        });

        return response;
      } catch (e) {
        if (_get(e, ['status']) === 404) {
          return 0;
        }

        throw e;
      }
    },
  }),
});
